export const GET_DEVICES = "GET_DEVICES";
export const GET_DEVICES_SUCCESS = "GET_DEVICES_SUCCESS";
export const GET_DEVICES_FAILED = "GET_DEVICES_FAILED";
